


import './lib.js'
import './box-height.js'
import './lazyload.js'
import './form-validation.js'
import './business-form.js'
import './lightbox.js'
import './google-map.js'
import './accessible-bundle.js'
import './c2c-gtag.js'

window.dom = {
	header : document.getElementById('top_fix'),
	crumbs : document.querySelector('.crumb_strip'),
	adminbar : document.getElementById('wpadminbar'),
	wrapper : document.getElementById('wrapper')
};

/* ===================================================== HEADER SCRIPTS =========================================== */
function Handle_Top(el){
	var self = this;
	this.elem = (el) ? el : 'wrapper';
	this.wrapper = document.getElementById('wrapper');
	this.top_fix = document.getElementById('top_fix');
	this.htmlTag = document.querySelector('html');
	this.htmlMar = function(){return parseInt(window.getComputedStyle(self.htmlTag, null).getPropertyValue('margin-top'))};
	this.internal_header = document.querySelector('.title_strip');
	this.is_home = (document.body.className.indexOf('home') > -1);
}
	Handle_Top.prototype.sticky_header = function(){
		//if(viewport().width > 1000){
			if(window.pageYOffset > dom.header.offsetHeight){
				if(document.body.className.indexOf(' sticky_header') === -1){
					document.body.className += " sticky_header";
				}
			} else {
				document.body.className = document.body.className.replace(" sticky_header","");
			}
		//}
	};
	Handle_Top.prototype.wrapper_pad = function(){
		var self = this;
		function recourse(){
			var adminHeight = dom.adminbar ? dom.adminbar.offsetHeight : 0;
			var top_fix_height = top_fix.offsetHeight;
			self.top_fix.style.top = self.htmlMar() + "px";
			self.wrapper.style.paddingTop = top_fix_height   + "px";
			
			setTimeout(recourse,20);
		}
		recourse();
	};
	Handle_Top.prototype.a11y_btn_pos = function(){
		function recourse(){
			var btns = document.querySelectorAll('.iAccessibility-menu-button,.iAccessibility-menu');
			if(btns.length){
				[].forEach.call(btns,function(btn){
					var adminHeight = dom.adminbar ? dom.adminbar.offsetHeight : 0;
					btn.style.top = dom.header.offsetHeight + adminHeight -1 + 'px'; 
				});
			}
			setTimeout(recourse,30);
		}
		recourse();
	};
	

var handle_top = new Handle_Top();
handle_top.wrapper_pad();
handle_top.sticky_header();
window.addEventListener('load',handle_top.sticky_header);
window.addEventListener('scroll',handle_top.sticky_header);
handle_top.a11y_btn_pos();

function Mobile_Menu(args){
	var it = this;
	this.holder = document.querySelector(args.holder);
	this.btn = document.querySelector(args.btn);
	this.panel = document.createElement('div');
	this.ul = "";
	this.extras = document.querySelectorAll(args.additional_html_classes.join(','));
	this.panel_foot = document.createElement('div');
	this.panelId = "mobile_menu_" + new Date().getTime();
	this.panelClass = "mobile_menu";
	this.big = true;
	this.small = true;
	this.panel_height = 0;

	/*[1] Build the mobile menu */

	this.methods_for_menu_construction = {
		sub_menus : function(){
			var lis = document.querySelectorAll('.mobile_menu li , #main_menu li ');
			[].forEach.call(lis,function(li){
				if(li.getElementsByTagName('ul')[0]){
					it.methods_for_sub_menus.print_sub_btn(li);
				}
			});
		},
		build : function(){
			it.panel.id = it.panelId;
			it.panel.className = it.panelClass;
			it.panel.innerHTML = it.holder.innerHTML;
			it.panel.appendChild(it.panel_foot);
			it.panel_foot.className = "mobile_menu_bottom";
			it.ul = it.panel.querySelector('ul');
			document.body.appendChild(it.panel);
		},
		destroy : function(){
			var existing = document.getElementById(it.panelId);
			if(existing) existing.parentNode.removeChild(existing);
		},
		decide : function(){
			/*decide on which screen width to build the menu 
			 and on which screen width to remove it*/
			 
			if(lib.viewport().width <= (args.mobile_view || 1024)){
				if(it.small){
					this.build();
					it.big = true;it.small = false;
					this.sub_menus();
				}
			} else {
				if(it.big){
					this.destroy();
					it.big = false;it.small = true;
				}
			}
			
		}
	};
	this.create_menu_panel = function(){
		it.methods_for_menu_construction.decide();
		window.addEventListener('resize',function(){it.methods_for_menu_construction.decide();});
		
	};

	/*[2] Functionality of the open menu button */

	this.methods_for_menu_openner = {
		adminbar : document.getElementById('wpadminbar'),
		top_fix : document.getElementById('top_fix'),
		panel_dim : function(){
			var top = (this.adminbar) ? this.adminbar.offsetHeight : 0;
			top += (this.top_fix) ? this.top_fix.offsetHeight : 0;
			it.panel.style.top = top + "px";
			it.panel.style.maxHeight = lib.viewport().height - top + "px";
		},
		open : function(btn){
			this.panel_dim();
			it.panel_height = it.ul.offsetHeight + it.panel_foot.offsetHeight;
			it.panel.style.height = it.panel_height + "px";
			it.ul.style.height = "calc(100% - " + it.panel_foot.offsetHeight + "px)";
			window.addEventListener('resize',function(){
				if(btn.className.indexOf('_on_') > -1){
					this.panel_dim();
					//it.panel.style.height = it.ul.offsetHeight + "px";
				}
			}.bind(this));
			
			it.panel.className += " open";
			dom.wrapper.className += " darken_screen";
		},
		close : function(){
			it.panel.className = it.panel.className.replace(' open','');
			it.panel_height = 0;
			it.panel.style.height = "";
			it.ul.style.height = "";
			dom.wrapper.className = dom.wrapper.className.replace(' darken_screen','');
		}
	};
	this.methods_for_menu_openner.panel_dim();
	this.main_btn_click = function(){
		
		it.btn.addEventListener('click',function(){
			if(this.className.indexOf('_on_') === -1){
				it.methods_for_menu_openner.open(this);
				this.className += " _on_";
			} else {
				it.methods_for_menu_openner.close();
				var active_footer_btn = it.panel.querySelector('.mobiel_menu_bottom_show._on_');
				if(active_footer_btn) active_footer_btn.click();
				this.className = this.className.replace(' _on_','');
			}
		})

	};

	/* [3] Sub menu */

	this.methods_for_sub_menus = {
		print_sub_btn : function(el){
			var ul = el.getElementsByTagName('ul')[0],
				sub_btn = document.createElement('button');
			sub_btn.className = "open_sub on";
			el.appendChild(sub_btn);
			var height;
			sub_btn.addEventListener('click',function(){

				if(this.className.indexOf(' on') > -1){

					ul.style.height = "auto";
					height = ul.clientHeight;
					ul.removeAttribute('style');
					jQuery(ul).animate({height:height},200,function(){
						ul.style.height = "auto";
					});
					it.panel_height += height;
					it.panel.style.height = it.panel_height + "px";

					this.className = this.className.replace(' on','');
				} else {
					
					it.panel_height -= ul.offsetHeight;
					
					jQuery(ul).animate({height:0},200);
					it.panel.style.height = it.panel_height + "px";
					
					this.className += " on";
				}
			});
			var a = el.querySelector('a');
			
			if ( !a ) return;
			var frag = a.href.split('#');

			if ( !a.href || frag[1] != undefined && !(frag[1].length) ){
				
				a.addEventListener('click',function(e){
					e.preventDefault();
					sub_btn.click();
				});
			}
		}
	};

	/* [4] Additional HTML in the bottom of the menu (search , lang , accesibility, and social links) */

	this.additional_html_selectors = [];
	this.footer_children = [];
	this.methods_for_additional_content = {

		
		
	};
	this.additional_content = function(){
		var appendFrom = [].map.call(this.extras,function(e){return e.parentNode}),
		appendTo = [].map.call(this.extras,function(e){var n = document.createElement('div');n.className = 'mobile_menu_extra'; return n;}),
		self = this,
		boolD = true,
		boolM = true;
		function make(){
			
			if(lib.viewport().width < args.mobile_view){
				if(boolM){
					appendTo.forEach(function(e,i){
						appendFrom[i].style.display = 'none';
						e.appendChild(self.extras[i]);
						self.panel_foot.insertBefore(e,self.panel_foot.firstChild);
					});
				} boolM = false;boolD = true;
			} else {
				if(boolD){
					appendFrom.forEach(function(e,i){
						appendFrom[i].style.display = '';
						e.appendChild(self.extras[i]);

					});
				} boolM = true; boolD = false;
			}
			
		}
		make();
		window.addEventListener('resize',make);
		
	}
	/* Finally, run all first-level methods! */
	this.init = (function(){
		for(var k in it){
			if(it.hasOwnProperty(k) && typeof it[k] === "function"){
				it[k]();
			}
		}

	}.bind(this))();
}
var main_menu = new Mobile_Menu({
	holder : "#main_menu",
	btn : "#button_clicker",
	open_list : '.to_open',
	mobile_view : 1000,
	additional_html_classes : [
		 

		'.top_lang_container',
		//'.top_mobile_phone',
		'.top_search_container',
		'.top_social_container'				
	]
});



	/* |_ TOP CONTROLS */

(function top_controls(){
	var top_controllers = document.querySelectorAll('.top_control');
	
	if(!top_controllers.length) return;
	var content_class = '.top_control_content'
	var Methods = function() {
		this.allow_top = true;
		this.show = false;
		this.panel_arrow = function(){
			var html = 
			'<div class="top_control_top_stroke">'+
				'<div class="tdb tc_stroke_1"></div>'+
				'<div class="tdb tc_arrow_h">'+
					'<svg class="show_selected_control_arrow" preserveAspectRatio="none" viewBox="0 0 100 100">'+
						'<polyline points="0,100 50,0 100,100"></polyline>'+
					'</svg>'+	
				'</div>'+
				'<div class="tdb tc_stroke_2"></div>'+			
			'</div>';
			return html;
		};
		this.close_others = function(btn){
			var contents = document.querySelectorAll('.top_control_content');
			var btns = document.querySelectorAll('.tc_btn');
			[].forEach.call(contents,function(c){
				c.style.display = "";
			});
			[].forEach.call(btns,function(_btn){
				if(_btn === btn) return;
				_btn.className = _btn.className.replace(' on_','');
			});
		};
		this.show_panel = function(btn,content){
			this.close_others(btn);
			if(btn.className.indexOf('on_') === -1){
				content.style.display = "block";
				btn.className += " on_";
			} else {
				content.style.display = "";
				btn.className = btn.className.replace(' on_','');
			}
			if(this.allow_top){
				var top = document.createElement('div');
				top.innerHTML = this.panel_arrow();
				content.insertBefore(top,content.childNodes[0]);
				this.allow_top = false;
			}
		};
		
	};
	[].forEach.call(top_controllers,function(tc){
		
			var btn = tc.querySelector('.tc_btn');
		
			var methods = new Methods();
			
			btn.addEventListener('click',function(){
				var content = tc.querySelector(content_class);
				if(content) {
					methods.show_panel(this,content);
				}
			});
		
		/* open iAccesibility panel */
		if(btn.className.indexOf('tc_b_accessibility') > -1){
			
			tc.addEventListener('click',function(){
				var a11y_btn = document.querySelector('.iAccessibility-menu-button');
				var iAccessibilityMenu = document.querySelector('.iAccessibility-menu');
				if(a11y_btn) a11y_btn.click();

				if(!iAccessibilityMenu.querySelector('.internally_close_acc_menu')){
					var internal_btn = document.createElement('button');
					internal_btn.className = 'internally_close_acc_menu';
					internal_btn.innerHTML = 'X';
					internal_btn.onclick = function(){if(a11y_btn) a11y_btn.click();};
					console.log(internal_btn);
					iAccessibilityMenu.insertBefore(internal_btn,iAccessibilityMenu.firstChild);
				}
			});

		}
		/* remove social controls if empty */
		if(tc.className.indexOf('tc_b_social') > -1){
					

			var h = document.querySelector('.top_social_container');
			
			if(!h) return;
			if(!h.children.length){
				 h.parentNode.parentNode.removeChild(h.parentNode);
			}
		}
		
		
	});
	
	
})();

function style_wpml(){
	var lang_holder = document.getElementById('lang_sel_list');
	
	if(!lang_holder) return;
	var html_lang = document.querySelector('html').lang.slice(0,2);
	
	var langs_list = lang_holder.querySelectorAll('li');
	[].forEach.call(langs_list,function(el){
		if(el.className.indexOf(html_lang) > -1){
			el.style.display = "none";
		}
	});
	if(lang_holder.querySelector('ul').children.length <= 1){
		var lang_btns = document.querySelectorAll('.tc_b_lang');
		[].forEach.call(lang_btns,function(el){
			el.style.display = "none";
			if(el.parentNode.className.indexOf('top_control') > -1){
				el.parentNode.style.display = "none";
			}
		});
	}
	
}
style_wpml();
/* ==================================================== HOME PAGE SCRIPTS =============================================== */



/* =================================================== FLEXIBLE SCRIPTS ========================================= */

function faq(){
	var btn = document.querySelectorAll('.open_ans');
	if(btn.length){
		var bl = btn.length;
		for(var i = 0; i < bl; i++){
			click(i);
		}
	}
	function click(x){
		btn[x].addEventListener('click',function(){
			var par = this.parentNode;
			var item = par.querySelectorAll('.fqqc')[0];
			var height = item.children[0].clientHeight;
			if(this.className.indexOf('on') === -1){
				item.style.height = height + "px";
				this.className += " on";
			} else {
				item.style.height = "0px";
				this.className = this.className.replace(' on','');
			}
			window.addEventListener('resize',function(){
				var height = item.children[0].clientHeight;
				item.style.height = height + "px";
			})
		})
	}
}


function mobile_side_menu(){
	var menu = document.getElementById('side_menu');
	if(menu){
		var main = document.querySelectorAll('.main_internal')[0],
			sib = document.querySelectorAll('.content_area')[0],
			title_strip = document.querySelectorAll('.title_strip')[0];
		var logo = document.getElementById('logo');
		var mm = document.createElement('div');
		var open_menu = document.createElement('button');
		open_menu.id = "open_inner_menu";
		open_menu.innerHTML = menu.dataset.mobiletext + 
		'<div class="menu_button"><div class="line"></div><div class="line"></div><div class="line"></div></div>';
		var mm_in = document.createElement('div');
		mm_in.id = "mobile_side_menu_inner";
		mm.appendChild(open_menu);
		mm.appendChild(mm_in);
		mm.id = "mobile_side_menu";
		var html = (menu) ? menu.innerHTML : "";
		main.insertBefore(mm,sib);
		
		make();
		window.addEventListener('resize',make);
		open_menu.onclick = function(){
			if(this.className.indexOf('on') === -1){
				mm_in.className += " open";
				this.className += " on";
			} else {
				mm_in.className = mm_in.className.replace(' open','');
				this.className = this.className.replace(' on','');
			}
		}
		mm_onscroll();
		window.addEventListener('scroll',mm_onscroll);
		
	}
	function make(){
		if(lib.viewport().width < fold){
			mm_in.innerHTML = html;
			menu.innerHTML = "";390
		} else {
			mm_in.innerHTML = "";
			menu.innerHTML = html;
		}
	}
	
	function mm_onscroll(){
		if(title_strip.getBoundingClientRect().bottom < logo.offsetHeight){
			if(mm.className.indexOf('fixed_mm') === -1) mm.className += " fixed_mm";
			mm.style.top = logo.offsetHeight + "px";
		} else {
			mm.className = mm.className.replace(' fixed_mm','');
			mm.removeAttribute('style');
		};
	}
	
}
mobile_side_menu();

		

jQuery(document).ready(function(){
	faq();
})
	//Friefox
	var FF = !(window.mozInnerScreenX == null);
	if(FF) {
	
		jQuery('.arrow_l.ha').addClass('ff')
	}

/* ajax script helpers */
function change_slider_image_on_mobile(){
	var imgs = document.querySelectorAll('.top_slider_img');
	if(!imgs.length) return;
	function fit_img_to_screen(){
		if(imgs.length){
			[].forEach.call(imgs,function(img){
				
				if(lib.viewport().width > 720){
					/*big screen:*/
					img.dataset.lazy = img.dataset.lazydesktop;
				} else {
					/*small screen:*/
					img.dataset.lazy = img.dataset.lazymobile;
				}
			});
		}
	}
	fit_img_to_screen();
	window.addEventListener('resize',fit_img_to_screen);

}
change_slider_image_on_mobile();

function loadStyle(src){
	var first_css = document.head.querySelector('link[rel="stylesheet"]');
	var link = document.createElement('link');
	link.rel = "stylesheet";
	link.href = template_dir + '/assets/js/css/'+ src +'.css';
	
	document.head.insertBefore(link,first_css);
}
function gets_scss_vars(data){
	var vars = data.split('$');
	vars = vars.filter(function(e){
		return e.indexOf(':') > -1;
	});
	var o = {};
	vars = vars.forEach(function(e){
		var prop = '$'+ e.slice(0, e.indexOf(':')).trim();
		var value = e.slice(e.indexOf(':') + 1, e.length).trim().replace(';','');
		o[prop] = value;
	});
	return o;
	
};

/* =================================================== SCRIPT AJAX LOADING ================================= */
!function($, window, document, _undefined){
$(document).ready(function(){

	var scssVars;

	/*accesibility bundle*/
	/* $.ajax({
		url: template_dir + '/assets/js/accessible-bundle.js',
		dataType: "script",
		cache : true,
		success: function(){
		}
	}); */
	$.ajax({
		url: template_dir + '/assets/css/_vars.scss',
		dataType: "text",
		cache : true,
		success: function(data){
			scssVars = gets_scss_vars(data);
			var cat_lists = document.querySelectorAll('.content_boxes');
			if(!cat_lists.length) return;
			[].forEach.call(cat_lists,function(item){
				
				var boxFour = item.className.indexOf('boxes_four') > -1;
				var viewports = [];
				var by = [];
				if(boxFour){
					viewports = [Infinity,parseInt(scssVars.$box4_fold),parseInt(scssVars.$box_4fold_min)];
					by = [4,2,1];
				} else {
					viewports = [Infinity,parseInt(scssVars.$box3_fold),parseInt(scssVars.$box_3fold_min)];
					by = [3,2,1];
					
				}
				align_height({
					selector : item.querySelectorAll('.box_title'),
					viewports :viewports,
					by : by,
					callback : function(e,els){
						[].forEach.call(els,function(el){
							var parent =  $(el).parents('.content_boxes');
							if(parent.hasClass('show_hidden_text') || parent.parent().hasClass('show_hidden_text')) return; 
							var $bf_boxin = $(el).parents('.bf_boxin');
							var a = $bf_boxin.find('.show_on_hover');
							$bf_boxin.css({'padding-bottom' : e + 'px'});
							if(!a[0]) return;
							var el = a[0].querySelector('.box_des_zero_height');
							if(!el)return;
							a.on('mouseenter',function(){
								el.style.height = el.firstChild.offsetHeight + 'px';
							});
							a.on('mouseleave',function(){
								el.style.height = '';
							});
						});
					}
				});
			});
			
		}
	});
	

	/*home slider */
	function home_slider(){
		var $slider = $('#home_slider');
		var n = 0;
		$slider.css({'opacity':0}).slick({
			rtl: rtl,/*rtl defined in footer.php*/
			slidesToScroll: 1,
			slidesToShow : 1,
			autoplay: true,
			autoplaySpeed : 5000,
			speed: 800,
			dots:true,
			lazyLoad: 'progressive',
			prevArrow : '<button class="home_slider_btn prev" aria-label="' + business.prev_button_label + '"></button>',
			nextArrow : '<button class="home_slider_btn next" aria-label="' + business.next_button_label + '"></button>',
			responsive : [
				{
					breakpoint: 720,
					lazyLoad: 'progressive',
				}
			]
			
		}).one('lazyLoaded',function(){
			$slider.animate({opacity:'1'},300);
		}).on('lazyLoaded',function(slide,e){
			var loadedImg = $(this).find('.slick-slide').eq(n).find('img');
			var src = loadedImg.attr('src') || loadedImg.data('lazymobile');

			loadedImg.parent().css( 'background-image','url("'+src+'")');
			n++;
		});
		
	}

	function swirling_slider(selector){

		var $slider = $(selector);
		$slider.slick({
			rtl: rtl,
			slidesToScroll: 3,
			slidesToShow : 3,
			autoplaySpeed : 5000,
			speed: 800,
			dots:false,
			prevArrow : '<button class="swiling_btn home_slider_btn prev" aria-label="' + business.prev_button_label + '"></button>',
			nextArrow : '<button class="swiling_btn home_slider_btn next" aria-label="' + business.next_button_label + '"></button>',
			lazyLoad : 'progressive',
			responsive : [
				{
					breakpoint: 750,
					settings : {
						slidesToScroll: 1,
						slidesToShow : 1,
					}
					
				}
			]
			
		});
		
	}
	function internal_slider(selector){

		var $slider = $(selector);
		$slider.slick({
			rtl: rtl,
			slidesToScroll: 1,
			slidesToShow : 1,
			autoplaySpeed : 5000,
			speed: 800,
			prevArrow : '<button class="intenal_slider-btn prev" aria-label="' + business.prev_button_label + '"></button>',
			nextArrow : '<button class="intenal_slider-btn next" aria-label="' + business.next_button_label + '"></button>',
			lazyLoad : 'progressive',
			
		});
		
	}

	
	if(document.querySelector('.js-getSlider')){
				
		home_slider();
		if(document.querySelector('.swirling_slider')){
			swirling_slider('.swirling_slider');
		}
		if(document.querySelector('.internal_slider')){
			internal_slider('.internal_slider')
		}
		
	}

	$('.flex-testimonials').slick({
        rtl: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        speed: 800,
        prevArrow: '<button class="swiling_btn home_slider_btn prev" aria-label="' + business.prev_button_label + '"></button>',
        nextArrow: '<button class="swiling_btn home_slider_btn next" aria-label="' + business.next_button_label + '"></button>',
        lazyLoad: 'progressive',
    });

	$('.more-text').on('click', function() {
		$(this).toggleClass('open');
		$(this).prev('.full-text').slideToggle();
	});

});

/**
* Smooth anchor jump
*/ 
$('a[href*="#"]:not([href="#"])').click(function(){
	if(location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if(target.length){
			$('html,body').stop(true, true).animate({
				scrollTop: target.offset().top - $('#top_fix').outerHeight()
			}, 500);
			return false;
		}
	}
});

}(jQuery, this, document);




// WEBPACK FOOTER //
// ./assets/js/main.js